module.exports = __webpack_public_path__ + "img/2018.10.949657d8.png";